export const Theme = {
  background: {
    primary: "#001d30",
    secondary: "#b0b7c3",
  },
  box: {
    borderRadius: "0.5rem",
  },
  fontSizes: {
    xsmall: "0.75rem",
    small: "0.875rem",
    medium: "1rem",
    large: "1.25rem",
    xlarge: "1.5rem",
    xxlarge: "2rem",
    xxxlarge: "3rem",
  },
  spacing: {
    xsmall: "0.25rem",
    small: "0.5rem",
    medium: "1rem",
    large: "2rem",
    xlarge: "4rem",
    xxlarge: "6rem",
  },
  colors: {
    primary: "#FFFFFF",
    secondary: "#F2F3F7",
    accent1: "#000000",
    accent2: "#A8FBCA",
    accentColor: "#67D9D4",
    border: "#ECECEC",
    danger: "#D4443A",
    font: {
      primary: "#000000",
      secondary: "#FFFFFF",
      tertiary: "#565869",
      grey1: "#212121",
      grey2: "#989898",
    },
    sidebar: {
      selected: "#DEFFFE",
    },
  },
  breakpoints: {
    xs: "600px",
    md: "768px",
    xl: "1440px",
  },
};
